// extracted by mini-css-extract-plugin
export default {"container":"InventoryForm_container__DedQa","body":"InventoryForm_body__8C3Sc","buttonCancel":"InventoryForm_buttonCancel__u3FQH","buttonSave":"InventoryForm_buttonSave__wB6Ij"};